<div *ngIf="items.length > 0 && isCatalogReady" class="Catalog uk-margin-xlarge-bottom">
	<div class="uk-child-width-1-2 uk-child-width-1-3@l uk-child-width-1-4@xl uk-grid" uk-grid>
		<div *ngFor="let item of items">
			<div class="CatalogCard" itemtype="http://schema.org/Product" itemprop="itemListElement" itemscope>
				<a class="uk-display-block" [routerLink]="cityService.city.CODE
					? ['/regions', cityService.city.CODE, 'catalog', item.CODE || item.ID]
				 	: ['/catalog', item.CODE || item.ID]">
					<!-- <span class="CatalogCard_Title">
						<span class="uk-h3 uk-width-1-1 uk-margin-remove">{{item.IBLOCK_SECTION.NAME}}</span>
					</span> -->
					<span class="CatalogCard_Img">
						<img *ngIf="item.PREVIEW_PICTURE" [src]="item.PREVIEW_PICTURE.SRC"
							 [alt]="item.PREVIEW_PICTURE.DESCRIPTION || item.NAME" loading="lazy">
						<span *ngIf="!item.PREVIEW_PICTURE" class="uk-h3 uk-margin-remove">Нет фото</span>
					</span>
				</a>
				<div class="CatalogCard_Bottom">
					<a class="CatalogCard_Description" [routerLink]="cityService.city.CODE
					? ['/regions', cityService.city.CODE, 'catalog', item.CODE || item.ID]
				 	: ['/catalog', item.CODE || item.ID]" itemprop="name">{{item.NAME}}</a>

					<a *ngIf="!item.OFFERS" class="CatalogCard_Price" [routerLink]="cityService.city.CODE
					? ['/regions', cityService.city.CODE, 'catalog', item.CODE || item.ID]
					 : ['/catalog', item.CODE || item.ID]" itemprop="offers" itemscope itemtype="http://schema.org/Offer">
						<meta itemprop="price" content="{{item.BASE_PRICE.PRICE}}">
						<meta itemprop="priceCurrency" content="RUB">
						<ng-template [ngIf]="item.BASE_PRICE.PRICE"><span
							*ngIf="item.BASE_PRICE.QUANTITY_FROM">от </span>{{item.BASE_PRICE.PRICE | currency: item.BASE_PRICE.CURRENCY : 'symbol' :'1.0-0'}}
						</ng-template>
						<ng-template [ngIf]="!item.BASE_PRICE.PRICE">Нет цены</ng-template>
					</a>
					<a *ngIf="item.OFFERS" class="CatalogCard_Price" [routerLink]="cityService.city.CODE
					? ['/regions', cityService.city.CODE, 'catalog', item.CODE || item.ID]
					 : ['/catalog', item.CODE || item.ID]" itemprop="offers" itemscope itemtype="http://schema.org/Offer">
						<meta itemprop="price" content="{{item.OFFERS[0].PRICE.RESULT_PRICE.DISCOUNT_PRICE}}">
						<meta itemprop="priceCurrency" content="RUB">
						<span
							*ngIf="item.OFFERS[0].PRICE.PRICE.QUANTITY_FROM">от </span>{{item.OFFERS[0].PRICE.RESULT_PRICE.DISCOUNT_PRICE | currency:item.OFFERS[0].PRICE.RESULT_PRICE.CURRENCY : 'symbol' : '1.0-0'}}
					</a>

					<!-- <span *ngIf="!item.IS_IN_COMPARE" class="CatalogCard_Compare" (click)="addToCompare(item)">
						<span class="IconItem IconItem--compare"></span>
						<span>К сравнению</span>
					</span>

					<span *ngIf="item.IS_IN_COMPARE" class="CatalogCard_Compare uk-text-primary" (click)="removeFromCompare(item)">
						<span class="IconItem IconItem--compare"></span>
						<span>В сравнении</span>
					</span> -->
				</div>
				<div class="CatalogCard_Hidden">
					<button *ngIf="!item.OFFERS" class="uk-button uk-button-primary uk-width-1-1"
							type="button"
							[disabled]='loadingState || !item.CAN_BUY'
							[ngClass]='loadingState ? "uk-button-loading" : ""'
							(click)="addToCart(item)"
					>Заказать
					</button>

					<button *ngIf="item.OFFERS" class="uk-button uk-button-primary uk-width-1-1"
							type="button"
							[disabled]='loadingState || !item.OFFERS[0].PRICE.PRICE.CAN_BUY'
							[ngClass]='loadingState ? "uk-button-loading" : ""'
							(click)="addToCart(item)"
					>Заказать
					</button>
				</div>
			</div>
		</div>
	</div>
</div>

<div *ngIf="items.length === 0 && isCatalogReady">
	<div class="uk-alert-warning" uk-alert>
		<h3>По данному фильтру не найдено товаров</h3>
	</div>
</div>

<div *ngIf="!isCatalogReady" class="Catalog uk-margin-xlarge-bottom">
	<div class="uk-child-width-1-2@m uk-child-width-1-3@l uk-child-width-1-4@xl uk-grid" uk-grid>
		<div *ngFor="let placeholder of placeLoaders">
			<div class="CatalogCard">
				<div class="CatalogCard_Img">
					<div class="Spinner">
						<div></div>
						<div></div>
					</div>
				</div>
				<div class="CatalogCard_Bottom">
					<span class="CatalogCard_Description Placeloader">Lorem ipsum dolor sit amet, consectetur adipisicing elit.</span>
					<span class="CatalogCard_Price Placeloader">Lorem ipsum.</span>
				</div>
			</div>
		</div>
	</div>
</div>
